module.exports = "<p>\r\n  bet works!\r\n</p>\r\n"